import React from 'react';

import PropTypes from 'prop-types';

const CalendarIcon = ({ color = 'currentColor', size = '1em', ...rest }) => {
  return (
    <svg
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="11.5"
        width="64"
        height="54"
        rx="3.5"
        stroke={color}
        strokeWidth="3"
      />
      <rect
        x="12.5"
        y="1.5"
        width="6"
        height="17"
        rx="3"
        fill="white"
        stroke={color}
        strokeWidth="3"
      />
      <rect
        x="48.5"
        y="1.5"
        width="6"
        height="17"
        rx="3"
        fill="white"
        stroke={color}
        strokeWidth="3"
      />
      <rect x="10" y="23" width="55" height="3" rx="1.5" fill={color} />
      <mask id="path-5-inside-1" fill="white">
        <rect x="7" y="32" width="10" height="10" rx="2" />
      </mask>
      <rect
        x="7"
        y="32"
        width="10"
        height="10"
        rx="2"
        fill="white"
        stroke={color}
        strokeWidth="6"
        mask="url(#path-5-inside-1)"
      />
      <mask id="path-6-inside-2" fill="white">
        <rect x="7" y="46" width="10" height="10" rx="2" />
      </mask>
      <rect
        x="7"
        y="46"
        width="10"
        height="10"
        rx="2"
        fill="white"
        stroke={color}
        strokeWidth="6"
        mask="url(#path-6-inside-2)"
      />
      <mask id="path-7-inside-3" fill="white">
        <rect x="21" y="32" width="10" height="10" rx="2" />
      </mask>
      <rect
        x="21"
        y="32"
        width="10"
        height="10"
        rx="2"
        fill="white"
        stroke={color}
        strokeWidth="6"
        mask="url(#path-7-inside-3)"
      />
      <mask id="path-8-inside-4" fill="white">
        <rect x="21" y="46" width="10" height="10" rx="2" />
      </mask>
      <rect
        x="21"
        y="46"
        width="10"
        height="10"
        rx="2"
        fill="white"
        stroke={color}
        strokeWidth="6"
        mask="url(#path-8-inside-4)"
      />
      <mask id="path-9-inside-5" fill="white">
        <rect x="35" y="32" width="10" height="10" rx="2" />
      </mask>
      <rect
        x="35"
        y="32"
        width="10"
        height="10"
        rx="2"
        fill="white"
        stroke={color}
        strokeWidth="6"
        mask="url(#path-9-inside-5)"
      />
      <mask id="path-10-inside-6" fill="white">
        <rect x="50" y="32" width="10" height="25" rx="2" />
      </mask>
      <rect
        x="50"
        y="32"
        width="10"
        height="25"
        rx="2"
        fill="white"
        stroke={color}
        strokeWidth="6"
        mask="url(#path-10-inside-6)"
      />
      <mask id="path-11-inside-7" fill="white">
        <rect x="35" y="46" width="10" height="10" rx="2" />
      </mask>
      <rect
        x="35"
        y="46"
        width="10"
        height="10"
        rx="2"
        fill="white"
        stroke={color}
        strokeWidth="6"
        mask="url(#path-11-inside-7)"
      />
    </svg>
  );
};

CalendarIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CalendarIcon;
